export const getEditedSections = dirtyFields => {
  const uniqueSections = new Set()

  Object.keys(dirtyFields).forEach(key => {
    // Get the section name (everything before the first period)
    const sectionName = key.split('.')[0]
    const fieldName = key.split('.')[1]

    if (fieldName === 'measurementImage') {
      uniqueSections.add(fieldName)
    } else {
      uniqueSections.add(sectionName)
    }
  })

  // Convert Set back to Array
  return Array.from(uniqueSections)
}
